var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 15,
    viewBox: "0 0 30 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V15H30V0Z",
    fill: "#01411C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C18.3137 12 21 9.76142 21 7C21 4.23858 18.3137 2 15 2C11.6863 2 9 4.23858 9 7C9 9.76142 11.6863 12 15 12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4383 9.31225C22.7086 7.72972 22.9131 5.00357 20.895 3.22322C18.877 1.44288 15.4006 1.28252 13.1303 2.86505C10.86 4.44758 10.6555 7.17372 12.6735 8.95407C14.6916 10.7344 18.168 10.8948 20.4383 9.31225Z",
    fill: "#01411C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4379 3.63739L19.9653 5.86708L16.2493 5.22818L19.7345 4.03225L17.8113 6.6062L17.4379 3.63739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/pk.cbd9e3feffd1ec262a1062472609ee9f.svg";
export { ForwardRef as ReactComponent };